<template>
  <div>
      <div class="modal-body modal-primary" v-show="newContributors.loading" style="min-height: 400px;">
          <div class="row">
              <div class="col-sm-12 center-block">
                  <img src="/assets/images/link_inactive.svg" class="spin-img" style="margin:10px; margin-top:150px">
              </div>
          </div>
      </div>
      <div class="modal-body modal-primary" v-show="!newContributors.loading">
          <div class="export-button row">
              <div class="form-group has-feedback col-xs-12">
                  <!-- <ui-select ng-model="selectedVersion.version" theme="selectize" on-select="newContributors = getContributors($select.selected.version)">
                      <ui-select-match placeholder="select version from ..." allow-clear="true">
                          <div ng-if="$select.selected.committed_at">Version from {{$select.selected.committed_at | date: 'medium'}}</div>
                          <div ng-if="$select.selected.text">{{$select.selected.text}}</div>
                      </ui-select-match>
                      <ui-select-choices repeat="version in history | filter: $select.search">
                          <span ng-bind-html="version.committed_at | highlight: $select.search | date: 'medium'" ng-if="version.committed_at"></span>
                          <span ng-bind-html="version.text | highlight: $select.search" ng-if="!version.committed_at"></span>
                      </ui-select-choices>
                  </ui-select> -->
                  <el-select v-model="selectedVersion" placeholder="Select version from..." style="width: 100%">
                    <el-option v-for="(item, index) in history" :key="index" :label="item.committed_at" :value="item.version">
                      <span v-html="item.committed_at" v-if="item.committed_at"></span>
                      <span v-html="item.text" v-if="!item.committed_at"></span>
                    </el-option>
                  </el-select>
              </div>
            </div>

          <div class="well report" style="max-height: 500px; overflow-y:scroll">

              <div class="row" style="position: relative; padding-top: 0; padding-bottom: 25px;">
                  <div class="col-sm-6" style="text-align:right">
                      <div style="display: inline-block; vertical-align:bottom; line-height:1.2">{{gistName}}</div>
                  </div>
                  <div class="center-block" style="position:absolute; width:100%">
                      &nbsp;
                      <img src="static/images/linked.svg" class="icon" style="height:17px">&nbsp;
                  </div>
                  <div class="col-sm-6">
                      <div style="display: inline-block; vertical-align:bottom; line-height:1.2">{{ claItem.owner }} / {{ claItem.repo }}</div>
                  </div>
              </div>
              <div class="row" style="margin-top:10px">
                  <div class="col-sm-offset-1 col-sm-5 clickable" style="border-bottom: solid 1px lightgray; padding-bottom: 10px;" @click="column = 'user_name'; reverse = !reverse;">Contributor &nbsp;
                      <span class="fa" :class="reverse ?'fa-caret-down':'fa-caret-up'" v-show="column=='user_name'"></span>
                  </div>
                  <div class="col-sm-5 clickable" style="border-bottom: solid 1px lightgray; padding-bottom: 10px;" @click="column = 'signed_at'; reverse = !reverse;">Date &nbsp;
                      <span class="fa" :class="reverse ?'fa-caret-down':'fa-caret-up'" v-show="column=='signed_at'"></span>
                  </div>
              </div>

              <div class="row" v-for="(contributor, index) in myContributors" :key="index">
                  <!-- <a class="col-sm-offset-1 col-sm-5" ng-href="{{contributor.html_url}}" target="space" >{{contributor.user_name}}</a> -->
                  <div class="col-sm-offset-1 col-sm-5">{{contributor.user_name}}</div>
                  <div class="col-sm-5">{{contributor.signed_at}}</div>
              </div>
          </div>
      </div>

      <div class="modal-body modal-primary" v-show="!newContributors.loading">
          <span v-show="myContributors.length >= 0">
              <b>{{myContributors.length}}</b> contributors signed this CLA</span>
      </div>

  </div>
</template>

<script>
import {getSignatures} from '@/api/home'
export default {
  props:{
    historys:{},
    claItem:{},
    gistName:{
      type:String,
      default:''
    }
	},
  data() {
    return {
			reverse: false,
      column: 'user_name',
			newContributors: {loading: false},
			selectedVersion:this.historys[0].version,
			myContributors:[]
    }
	},
	created() {
		this.getContributors(this.selectedVersion);
	},
  methods: {
		getContributors() {
			this.myContributors = [];
			getSignatures({
				repoId: this.claItem.repoId,
				gist: {
						gist_url: this.claItem.gist,
						gist_version: this.selectedVersion
				},
				sharedGist: this.claItem.sharedGist
			}).then((res) =>{
				if (res && res.length > 0) {
						res.forEach((signature) =>{
								var contributor = {};
								contributor.user_name = signature.user;
								contributor.signed_at = signature.created_at;
								console.log(contributor);
								this.myContributors.push(contributor);
						});
					}
			});
		},
	},
  computed: {
    history() {
      return this.historys.concat([{text: 'All versions'}]);
		}
  },
	watch: {
		selectedVersion() {
			this.getContributors(this.selectedVersion);
		}
  }
}

</script>
<style >
</style>



// WEBPACK FOOTER //
// src/javascript/home/components/modal/report.vue